export default __webpack_public_path__ + "static/media/flag-kenya.8c1c5c37.svg";